import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ConversationList } from "@/components/chat/ConversationList";
import { ChatThread } from "@/components/chat/ChatThread";

export default function MessagesPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const [list, setList] = useState(null);
  const loadList = useCallback(() => api.get("/conversations").then((r) => setList(r.data)), []);

  useEffect(() => {
    loadList();
    const t = setInterval(loadList, 10000);
    return () => clearInterval(t);
  }, [loadList]);

  return (
    <main className="max-w-7xl mx-auto px-0 sm:px-6 lg:px-10 pt-8 sm:pt-12" data-testid="messages-page">
      <div className="px-6 sm:px-0">
        <p className="eyebrow">Messaggi</p>
        <h1 className="font-serif text-4xl sm:text-5xl mt-3">Le tue conversazioni</h1>
      </div>
      <div className="mt-8 border border-white/5 bg-[#0E1013] grid md:grid-cols-[320px_1fr] h-[calc(100vh-15rem)] min-h-[480px]">
        <aside className={`border-r border-white/5 overflow-y-auto ${id ? "hidden md:block" : ""}`}>
          <ConversationList list={list} activeId={id} meId={user.id} />
        </aside>
        <section className={`min-h-0 ${id ? "" : "hidden md:flex"} md:flex flex-col`}>
          {id ? <ChatThread convId={id} meId={user.id} onActivity={loadList} />
            : (
              <div className="flex-1 flex flex-col items-center justify-center text-center p-10 text-neutral-500" data-testid="messages-placeholder">
                <MessageCircle className="w-8 h-8 text-[#D4AF37]" strokeWidth={1.3} />
                <p className="font-serif text-2xl mt-4 text-neutral-300">Seleziona una conversazione</p>
              </div>
            )}
        </section>
      </div>
    </main>
  );
}
